<template>
  <div class="">
    <span @click="toggleJson" class="text-button">{{ showJson ? 'Hide' : 'Show' }} json</span>
    <p v-if="!formattedJson">Error: No JSON input</p>
    <pre class="font-mono" v-else-if="json && showJson">{{ formattedJson }}</pre>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const formattedJson = ref('')
const props = defineProps({
  json: {
    type: Object,
    default: null
  }
})

const formatJson = (json) => {
  formattedJson.value = JSON.stringify(json, null, 2)
}
const showJson = ref(false)

function toggleJson() {
  showJson.value = !showJson.value
}

watch(
  () => props.json,
  (newVal) => {
    if (newVal) {
      formatJson(newVal)
    }
  },
  { immediate: true }
)
</script>
